import type { NavCounts } from '@services/nav.service';
import { TICKETS_WAITING_ON_ME_PATH } from '@features/tickets/ticketsQueue';

export interface NavBadge {
  count: number;
  /** Red: something in this count is past its SLA. */
  urgent: boolean;
  /** Spoken / tooltip text, e.g. "7 waiting, 2 past SLA". */
  label: string;
  /** Where the item links while it has a badge: the view of exactly what was counted. */
  to?: string;
}

/** The badge never grows past three characters, so it fits the glyph rail. */
export function formatBadgeCount(count: number): string {
  return count > 99 ? '99+' : String(count);
}

/** The badge for a nav item, or null for no badge (zero, unknown, or not a counted item). */
export function navBadgeFor(path: string, counts: NavCounts | null): NavBadge | null {
  if (!counts) return null;
  switch (path) {
    case '/tickets': {
      const { waiting = 0, breached = 0 } = counts.tickets ?? {};
      if (waiting <= 0) return null;
      return {
        count: waiting,
        urgent: breached > 0,
        label: breached > 0 ? `${waiting} waiting, ${breached} past SLA` : `${waiting} waiting`,
        to: TICKETS_WAITING_ON_ME_PATH,
      };
    }
    case '/live-chat': {
      const waiting = counts.liveChat?.waiting ?? 0;
      if (waiting <= 0) return null;
      // Live Chat already opens on its Waiting queue, so no special link.
      return { count: waiting, urgent: false, label: `${waiting} waiting` };
    }
    default:
      return null;
  }
}
